import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import ValuationForm from '../components/ValuationForm';
import TrustSection from '../components/TrustSection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <ValuationForm />
      <TrustSection />
      <Footer />
    </div>
  );
};

export default HomePage;